(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[453],{

/***/ 3905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MDXContext": function() { return /* binding */ MDXContext; },
/* harmony export */   "MDXProvider": function() { return /* binding */ MDXProvider; },
/* harmony export */   "mdx": function() { return /* binding */ createElement; },
/* harmony export */   "useMDXComponents": function() { return /* binding */ useMDXComponents; },
/* harmony export */   "withMDXComponents": function() { return /* binding */ withMDXComponents; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};

var MDXContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var withMDXComponents = function withMDXComponents(Component) {
  return function (props) {
    var allComponents = useMDXComponents(props.components);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _extends({}, props, {
      components: allComponents
    }));
  };
};
var useMDXComponents = function useMDXComponents(components) {
  var contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext);
  var allComponents = contextComponents;

  if (components) {
    allComponents = isFunction(components) ? components(contextComponents) : _objectSpread2(_objectSpread2({}, contextComponents), components);
  }

  return allComponents;
};
var MDXProvider = function MDXProvider(props) {
  var allComponents = useMDXComponents(props.components);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(MDXContext.Provider, {
    value: allComponents
  }, props.children);
};

var TYPE_PROP_NAME = 'mdxType';
var DEFAULTS = {
  inlineCode: 'code',
  wrapper: function wrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}, children);
  }
};
var MDXCreateElement = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
  var propComponents = props.components,
      mdxType = props.mdxType,
      originalType = props.originalType,
      parentName = props.parentName,
      etc = _objectWithoutProperties(props, ["components", "mdxType", "originalType", "parentName"]);

  var components = useMDXComponents(propComponents);
  var type = mdxType;
  var Component = components["".concat(parentName, ".").concat(type)] || components[type] || DEFAULTS[type] || originalType;

  if (propComponents) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _objectSpread2(_objectSpread2({
      ref: ref
    }, etc), {}, {
      components: propComponents
    }));
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _objectSpread2({
    ref: ref
  }, etc));
});
MDXCreateElement.displayName = 'MDXCreateElement';
function createElement (type, props) {
  var args = arguments;
  var mdxType = props && props.mdxType;

  if (typeof type === 'string' || mdxType) {
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = MDXCreateElement;
    var newProps = {};

    for (var key in props) {
      if (hasOwnProperty.call(props, key)) {
        newProps[key] = props[key];
      }
    }

    newProps.originalType = type;
    newProps[TYPE_PROP_NAME] = typeof type === 'string' ? type : mdxType;
    createElementArgArray[1] = newProps;

    for (var i = 2; i < argsLength; i++) {
      createElementArgArray[i] = args[i];
    }

    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, args);
}




/***/ }),

/***/ 967:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AirtableBase = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AirtableBase = function AirtableBase(_ref) {
  var airtableBaseId = _ref.airtableBaseId,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? '' : _ref$layout,
      _ref$viewControls = _ref.viewControls,
      viewControls = _ref$viewControls === void 0 ? 'on' : _ref$viewControls;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "airtable-base",
    title: "airtable-".concat(airtableBaseId),
    src: "https://airtable.com/embed/".concat(airtableBaseId, "?backgroundColor=green&").concat(!layout ? "" : "layout=".concat(layout, "&"), "viewControls=").concat(viewControls),
    width: "100%",
    height: "533",
    style: {
      background: 'transparent',
      border: '1px solid #ccc'
    },
    frameBorder: "0"
  })));
};

exports.AirtableBase = AirtableBase;

/***/ }),

/***/ 1696:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AirtableForm = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AirtableForm = function AirtableForm(_ref) {
  var airtableFormId = _ref.airtableFormId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "airtable-form",
    title: "airtable-".concat(airtableFormId),
    src: "https://airtable.com/embed/".concat(airtableFormId, "?backgroundColor=green"),
    width: "100%",
    height: "533",
    style: {
      background: 'transparent',
      border: '1px solid #ccc'
    },
    frameBorder: "0"
  })));
};

exports.AirtableForm = AirtableForm;

/***/ }),

/***/ 1177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "AirtableBase", ({
  enumerable: true,
  get: function get() {
    return _airtableBase.AirtableBase;
  }
}));
Object.defineProperty(exports, "AirtableForm", ({
  enumerable: true,
  get: function get() {
    return _airtableForm.AirtableForm;
  }
}));

var _airtableBase = __webpack_require__(967);

var _airtableForm = __webpack_require__(1696);

/***/ }),

/***/ 7818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Buzzsprout = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Buzzsprout = function Buzzsprout(_ref) {
  var buzzsproutId = _ref.buzzsproutId,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '200' : _ref$height;
  var regex = /^\d{7}\/\d{7}-[\w|\W]+/;

  if (!regex.test(buzzsproutId)) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "buzzsprout",
    className: "buzzsprout-mdx-embed",
    title: "buzzsprout-".concat(buzzsproutId),
    src: "https://www.buzzsprout.com/".concat(buzzsproutId, "?client_source=admin&amp;iframe=true"),
    width: width,
    height: height,
    frameBorder: "0",
    scrolling: "no"
  })));
};

exports.Buzzsprout = Buzzsprout;

/***/ }),

/***/ 5738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Buzzsprout", ({
  enumerable: true,
  get: function get() {
    return _buzzsprout.Buzzsprout;
  }
}));

var _buzzsprout = __webpack_require__(7818);

/***/ }),

/***/ 7981:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Cinnamon = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _utils = __webpack_require__(3781);

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Cinnamon = function Cinnamon(_ref) {
  var cinnamonId = _ref.cinnamonId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cinnamon-mdx-embed",
    style: _objectSpread({
      position: 'relative',
      width: '100%'
    }, (0, _utils.getPadding)('16:9'))
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "cinnamon",
    src: "https://cinnamon.video/embed?v=".concat(cinnamonId),
    frameBorder: "0",
    allow: "monetization; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};

exports.Cinnamon = Cinnamon;

/***/ }),

/***/ 627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Cinnamon", ({
  enumerable: true,
  get: function get() {
    return _cinnamon.Cinnamon;
  }
}));

var _cinnamon = __webpack_require__(7981);

/***/ }),

/***/ 9436:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CodePen = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CodePen = function CodePen(_ref) {
  var codePenId = _ref.codePenId,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 500 : _ref$height,
      _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? 'result' : _ref$tabs,
      _ref$clickToLoad = _ref.clickToLoad,
      clickToLoad = _ref$clickToLoad === void 0 ? false : _ref$clickToLoad,
      _ref$editable = _ref.editable,
      editable = _ref$editable === void 0 ? false : _ref$editable,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    height: height
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "codepen",
    title: "codepen-".concat(codePenId),
    className: "codepen-mdx-embed",
    height: height,
    style: {
      width: '100%'
    },
    scrolling: "no",
    src: "https://codepen.io/team/codepen/embed".concat(clickToLoad ? '/preview' : '', "/").concat(codePenId, "?height=265&theme-id=").concat(theme, "&default-tab=").concat(tabs).concat(editable ? '&editable=true' : ''),
    frameBorder: "no",
    allowFullScreen: true
  }));
};

exports.CodePen = CodePen;

/***/ }),

/***/ 9131:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "CodePen", ({
  enumerable: true,
  get: function get() {
    return _codepen.CodePen;
  }
}));

var _codepen = __webpack_require__(9436);

/***/ }),

/***/ 2636:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CodeSandbox = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CodeSandbox = function CodeSandbox(_ref) {
  var codeSandboxId = _ref.codeSandboxId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "codesandbox",
    title: "codeSandbox-".concat(codeSandboxId),
    className: "codesandbox-mdx-embed",
    src: "https://codesandbox.io/embed/".concat(codeSandboxId),
    allow: "geolocation; microphone; camera; midi; vr; accelerometer; gyroscope; payment; ambient-light-sensor; encrypted-media; usb",
    sandbox: "allow-modals allow-forms allow-popups allow-scripts allow-same-origin",
    style: {
      width: '100%',
      height: '500px',
      border: 0,
      borderRadius: '4px',
      overflow: ' hidden'
    }
  }));
};

exports.CodeSandbox = CodeSandbox;

/***/ }),

/***/ 9186:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "CodeSandbox", ({
  enumerable: true,
  get: function get() {
    return _codesandbox.CodeSandbox;
  }
}));

var _codesandbox = __webpack_require__(2636);

/***/ }),

/***/ 1015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.EggheadLesson = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _utils = __webpack_require__(3781);

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EggheadLesson = function EggheadLesson(_ref) {
  var lessonId = _ref.lessonId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "egghead-lesson-mdx-embed",
    style: _objectSpread({
      position: 'relative',
      width: '100%'
    }, (0, _utils.getPadding)('16:9'))
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "egghead-lesson",
    title: "egghead-".concat(lessonId),
    src: "https://egghead.io/lessons/".concat(lessonId, "/embed"),
    frameBorder: "0",
    allow: "autoplay; fullscreen",
    allowFullScreen: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};

exports.EggheadLesson = EggheadLesson;

/***/ }),

/***/ 2269:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "EggheadLesson", ({
  enumerable: true,
  get: function get() {
    return _eggheadLesson.EggheadLesson;
  }
}));

var _eggheadLesson = __webpack_require__(1015);

/***/ }),

/***/ 3749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Figma = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Figma = function Figma(_ref) {
  var title = _ref.title,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 450 : _ref$height,
      url = _ref.url;
  var regex = /(file|proto)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/;

  if (!regex.test(url)) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    height: height
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "figma",
    title: "figma-".concat(title),
    className: "figma-mdx-embed",
    height: height,
    style: {
      width: '100%'
    },
    scrolling: "no",
    src: "https://www.figma.com/embed?embed_host=mdx-embed&url=https://www.figma.com/".concat(url),
    frameBorder: "no",
    allowFullScreen: true
  }));
};

exports.Figma = Figma;

/***/ }),

/***/ 941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Figma", ({
  enumerable: true,
  get: function get() {
    return _figma.Figma;
  }
}));

var _figma = __webpack_require__(3749);

/***/ }),

/***/ 9130:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Flickr = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(2835);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Flickr = function Flickr(_ref) {
  var flickrLink = _ref.flickrLink;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleFlickrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "data-testid": "flickr",
    className: "flickr-embed-mdx",
    "data-flickr-embed": "true",
    "data-header": "true",
    "data-footer": "true"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "https://live.staticflickr.com/".concat(flickrLink),
    width: "100%",
    height: "auto",
    alt: flickrLink
  })));
};

exports.Flickr = Flickr;

/***/ }),

/***/ 3926:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Flickr", ({
  enumerable: true,
  get: function get() {
    return _flickr.Flickr;
  }
}));

var _flickr = __webpack_require__(9130);

/***/ }),

/***/ 2835:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleFlickrLoad = exports.flickrClassNames = void 0;

var _utils = __webpack_require__(3781);

var isFlickrScriptAdded = false;
var flickrClassNames = [".flickr-embed"].join(",");
exports.flickrClassNames = flickrClassNames;
var flickrEmbedUrl = "https://embedr.flickr.com/assets/client-code.js";

var handleFlickrLoad = function handleFlickrLoad() {
  if (document.querySelector(flickrClassNames) !== null) {
    if (!isFlickrScriptAdded) {
      (0, _utils.createScriptTag)(flickrEmbedUrl, null);
      isFlickrScriptAdded = true;
      return {
        status: 'createScriptTag'
      };
    }
  }

  return {
    status: 'null'
  };
};

exports.handleFlickrLoad = handleFlickrLoad;

/***/ }),

/***/ 5682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.GeneralObserver = void 0;

var _react = _interopRequireWildcard(__webpack_require__(7294));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var GeneralObserver = function GeneralObserver(_ref) {
  var children = _ref.children,
      onEnter = _ref.onEnter,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 0 : _ref$height;
  var ref = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isChildVisible = _useState2[0],
      setIsChildVisible = _useState2[1];

  (0, _react.useEffect)(function () {
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          entry = _ref3[0];

      if (entry.intersectionRatio > 0) {
        setIsChildVisible(true);
        onEnter && onEnter();
      }
    }, {
      root: null,
      rootMargin: '400px',
      threshold: 0
    });

    if (ref && ref.current) {
      observer.observe(ref.current);
    }
  }, [ref]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    "data-testid": "general-observer",
    className: "mdx-embed"
  }, isChildVisible ? children : /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: height,
      width: '100%'
    }
  }));
};

exports.GeneralObserver = GeneralObserver;

/***/ }),

/***/ 7051:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "GeneralObserver", ({
  enumerable: true,
  get: function get() {
    return _generalObserver.GeneralObserver;
  }
}));

var _generalObserver = __webpack_require__(5682);

/***/ }),

/***/ 4925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Gist = void 0;

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _utils = __webpack_require__(3781);

var _generalObserver = __webpack_require__(7051);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Gist = function Gist(_ref) {
  var gistLink = _ref.gistLink;

  var _useState = (0, _react.useState)({
    isLoading: true,
    div: '',
    file: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      gistResponse = _useState2[0],
      setGistResponse = _useState2[1];

  var root = "https://gist.github.com/";
  var gistId = gistLink.split('/')[1];
  var gistEmbedScript = "".concat(root).concat(gistLink, ".json?callback=gist_callback_").concat(gistId);
  (0, _react.useEffect)(function () {
    window["gist_callback_".concat(gistId)] = function (gist) {
      (0, _utils.createStyleSheet)(gist.stylesheet);
      setGistResponse({
        isLoading: false,
        div: gist.div,
        file: gist.files[0]
      });
    };

    (0, _utils.createScriptTag)(gistEmbedScript, null);
  }, [gistId, gistEmbedScript]);
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, !gistResponse.isLoading && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "gist",
    className: "gist-mdx-embed",
    dangerouslySetInnerHTML: {
      __html: gistResponse.div
    }
  }));
};

exports.Gist = Gist;

/***/ }),

/***/ 332:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Gist", ({
  enumerable: true,
  get: function get() {
    return _gist.Gist;
  }
}));

var _gist = __webpack_require__(4925);

/***/ }),

/***/ 376:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Instagram", ({
  enumerable: true,
  get: function get() {
    return _instagram.Instagram;
  }
}));

var _instagram = __webpack_require__(2172);

/***/ }),

/***/ 2172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Instagram = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(3800);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Instagram = function Instagram(_ref) {
  var instagramId = _ref.instagramId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleInstagrmLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("blockquote", {
    "data-testid": "instagram",
    className: "instagram-media instagram-mdx-embed",
    "data-instgrm-version": "12"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://instagram.com/p/".concat(instagramId)
  }, typeof window !== 'undefined' && !window.instgrm ? 'Loading' : '')));
};

exports.Instagram = Instagram;

/***/ }),

/***/ 3800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleInstagrmLoad = exports.instgrmClassNames = void 0;

var _utils = __webpack_require__(3781);

var isInstgrmScriptAdded = false;
var instgrmClassNames = [".instagram-media", ".instagram-media-rendered"].join(",");
exports.instgrmClassNames = instgrmClassNames;
var instgrmEmbedUrl = "https://www.instagram.com/embed.js";

var instgrmProcess = function instgrmProcess() {
  if (typeof window.instgrm !== "undefined" && window.instgrm.Embeds && typeof window.instgrm.Embeds.process === "function") {
    window.instgrm.Embeds.process();
  }
};

var handleInstagrmLoad = function handleInstagrmLoad() {
  if (document.querySelector(instgrmClassNames) !== null) {
    if (!isInstgrmScriptAdded) {
      (0, _utils.createScriptTag)(instgrmEmbedUrl, null);
      isInstgrmScriptAdded = true;
      return {
        status: 'createScriptTag'
      };
    }
  }

  instgrmProcess();
  return {
    status: 'instgrmProcess'
  };
};

exports.handleInstagrmLoad = handleInstagrmLoad;

/***/ }),

/***/ 3501:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Lbry", ({
  enumerable: true,
  get: function get() {
    return _lbry.Lbry;
  }
}));

var _lbry = __webpack_require__(2901);

/***/ }),

/***/ 2901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Lbry = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _utils = __webpack_require__(3781);

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Lbry = function Lbry(_ref) {
  var lbryId = _ref.lbryId,
      _ref$skipTo = _ref.skipTo,
      skipTo = _ref$skipTo === void 0 ? {
    s: 0
  } : _ref$skipTo;
  var s = skipTo.s;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "lbry-mdx-embed",
    style: _objectSpread({
      position: 'relative',
      width: '100%'
    }, (0, _utils.getPadding)('16:9'))
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "lbry",
    title: "lbry-".concat(lbryId),
    src: "https://lbry.tv/$/embed/".concat(lbryId, "?t=").concat(s),
    frameBorder: "0",
    allow: "fullscreen",
    allowFullScreen: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};

exports.Lbry = Lbry;

/***/ }),

/***/ 9744:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "LinkedInBadge", ({
  enumerable: true,
  get: function get() {
    return _linkedinBadge.LinkedInBadge;
  }
}));

var _linkedinBadge = __webpack_require__(2829);

/***/ }),

/***/ 2829:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LinkedInBadge = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(3342);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LinkedInBadge = function LinkedInBadge(_ref) {
  var username = _ref.username,
      _ref$badgeType = _ref.badgeType,
      badgeType = _ref$badgeType === void 0 ? 'vertical' : _ref$badgeType,
      _ref$badgeSize = _ref.badgeSize,
      badgeSize = _ref$badgeSize === void 0 ? 'medium' : _ref$badgeSize,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'light' : _ref$theme,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en_US' : _ref$locale;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleLinkedInLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "linkedin-badge",
    className: "LI-profile-badge linkedin-badge-embed-mdx",
    "data-version": "v1",
    "data-size": badgeSize,
    "data-locale": locale,
    "data-type": badgeType,
    "data-theme": theme,
    "data-vanity": username
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "LI-simple-link",
    href: "https://uk.linkedin.com/in/".concat(username, "?trk=profile-badge")
  }, "Loading")));
};

exports.LinkedInBadge = LinkedInBadge;

/***/ }),

/***/ 3342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleLinkedInLoad = exports.linkedInClassNames = void 0;

var _utils = __webpack_require__(3781);

var isLinkedInScriptAdded = false;
var linkedInClassNames = [".LI-profile-badge", ".LI-simple-link"].join(",");
exports.linkedInClassNames = linkedInClassNames;
var linkedInBadgesUrl = "https://platform.linkedin.com/badges/js/profile.js";

var LIRenderAll = function LIRenderAll() {
  if (typeof window.LI !== "undefined" && typeof window.LIRenderAll === "function") {
    window.LIRenderAll();
  }
};

var handleLinkedInLoad = function handleLinkedInLoad() {
  if (document.querySelector(linkedInClassNames) !== null) {
    if (!isLinkedInScriptAdded) {
      (0, _utils.createScriptTag)(linkedInBadgesUrl, null);
      isLinkedInScriptAdded = true;
      return {
        status: 'createScriptTag'
      };
    }
  }

  LIRenderAll();
  return {
    status: 'null'
  };
};

exports.handleLinkedInLoad = handleLinkedInLoad;

/***/ }),

/***/ 7435:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.components = void 0;

var _airtable = __webpack_require__(1177);

var _buzzsprout = __webpack_require__(5738);

var _cinnamon = __webpack_require__(627);

var _codepen = __webpack_require__(9131);

var _codesandbox = __webpack_require__(9186);

var _egghead = __webpack_require__(2269);

var _figma = __webpack_require__(941);

var _flickr = __webpack_require__(3926);

var _gist = __webpack_require__(332);

var _instagram = __webpack_require__(376);

var _lbry = __webpack_require__(3501);

var _linkedin = __webpack_require__(9744);

var _pinterest = __webpack_require__(2035);

var _simplecast = __webpack_require__(5742);

var _soundcloud = __webpack_require__(9136);

var _spotify = __webpack_require__(2674);

var _strava = __webpack_require__(89);

var _snack = __webpack_require__(7594);

var _tiktok = __webpack_require__(7210);

var _twitch = __webpack_require__(6913);

var _twitter = __webpack_require__(9597);

var _vimeo = __webpack_require__(9710);

var _whimsical = __webpack_require__(5033);

var _wikipedia = __webpack_require__(3055);

var _wistia = __webpack_require__(3850);

var _youtube = __webpack_require__(837);

var components = {
  AirtableBase: _airtable.AirtableBase,
  AirtableForm: _airtable.AirtableForm,
  Buzzsprout: _buzzsprout.Buzzsprout,
  Cinnamon: _cinnamon.Cinnamon,
  CodePen: _codepen.CodePen,
  CodeSandbox: _codesandbox.CodeSandbox,
  EggheadLesson: _egghead.EggheadLesson,
  Figma: _figma.Figma,
  Flickr: _flickr.Flickr,
  Gist: _gist.Gist,
  Instagram: _instagram.Instagram,
  Lbry: _lbry.Lbry,
  LinkedInBadge: _linkedin.LinkedInBadge,
  Pin: _pinterest.Pin,
  PinterestBoard: _pinterest.PinterestBoard,
  PinterestFollowButton: _pinterest.PinterestFollowButton,
  SimplecastEpisode: _simplecast.SimplecastEpisode,
  SoundCloud: _soundcloud.SoundCloud,
  Spotify: _spotify.Spotify,
  Strava: _strava.Strava,
  Snack: _snack.Snack,
  TikTok: _tiktok.TikTok,
  Twitch: _twitch.Twitch,
  Tweet: _twitter.Tweet,
  TwitterFollowButton: _twitter.TwitterFollowButton,
  TwitterHashtagButton: _twitter.TwitterHashtagButton,
  TwitterList: _twitter.TwitterList,
  TwitterMentionButton: _twitter.TwitterMentionButton,
  TwitterTimeline: _twitter.TwitterTimeline,
  Vimeo: _vimeo.Vimeo,
  Whimsical: _whimsical.Whimsical,
  Wikipedia: _wikipedia.Wikipedia,
  Wistia: _wistia.Wistia,
  YouTube: _youtube.YouTube
};
exports.components = components;

/***/ }),

/***/ 1071:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "MDXEmbedProvider", ({
  enumerable: true,
  get: function get() {
    return _mdxEmbedProvider.MDXEmbedProvider;
  }
}));

var _mdxEmbedProvider = __webpack_require__(9030);

/***/ }),

/***/ 9030:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MDXEmbedProvider = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _react2 = __webpack_require__(3905);

var _components = __webpack_require__(7435);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MDXEmbedProvider = function MDXEmbedProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react2.MDXProvider, {
    components: _components.components
  }, children);
};

exports.MDXEmbedProvider = MDXEmbedProvider;

/***/ }),

/***/ 2035:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Pin", ({
  enumerable: true,
  get: function get() {
    return _pin.Pin;
  }
}));
Object.defineProperty(exports, "PinterestBoard", ({
  enumerable: true,
  get: function get() {
    return _pinterestBoard.PinterestBoard;
  }
}));
Object.defineProperty(exports, "PinterestFollowButton", ({
  enumerable: true,
  get: function get() {
    return _pinterestFollowButton.PinterestFollowButton;
  }
}));

var _pin = __webpack_require__(2284);

var _pinterestBoard = __webpack_require__(9530);

var _pinterestFollowButton = __webpack_require__(8485);

/***/ }),

/***/ 2284:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Pin = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(8739);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Pin = function Pin(_ref) {
  var pinId = _ref.pinId,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handlePinterestBuild)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "pinterest-pin pinterest-pin-mdx-embed",
    "data-testid": "pin",
    "data-pin-do": "embedPin",
    "data-pin-width": size,
    href: "https://www.pinterest.com/pin/".concat(pinId)
  }));
};

exports.Pin = Pin;

/***/ }),

/***/ 9530:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PinterestBoard = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(8739);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PinterestBoard = function PinterestBoard(_ref) {
  var pinterestLink = _ref.pinterestLink,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 400 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 250 : _ref$height,
      _ref$imageWidth = _ref.imageWidth,
      imageWidth = _ref$imageWidth === void 0 ? 80 : _ref$imageWidth,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'board' : _ref$variant;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handlePinterestBuild)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "pinterest-board pinterest-board-mdx-embed",
    "data-testid": "pinterest-board",
    "data-pin-do": "embed".concat(variant.charAt(0).toUpperCase()).concat(variant.slice(1)),
    "data-pin-board-width": width,
    "data-pin-scale-height": height,
    "data-pin-scale-width": imageWidth,
    href: "https://www.pinterest.com/".concat(pinterestLink)
  }));
};

exports.PinterestBoard = PinterestBoard;

/***/ }),

/***/ 8485:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PinterestFollowButton = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(8739);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PinterestFollowButton = function PinterestFollowButton(_ref) {
  var username = _ref.username;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handlePinterestBuild)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "pinterest-follow-button pinterest-follow-button-mdx-embed",
    "data-testid": "pinterest-follow-button",
    "data-pin-do": "buttonFollow",
    href: "https://www.pinterest.com/".concat(username, "/")
  }, "Follow @".concat(username)));
};

exports.PinterestFollowButton = PinterestFollowButton;

/***/ }),

/***/ 8739:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handlePinterestBuild = exports.pinterestClassNames = void 0;

var _utils = __webpack_require__(3781);

var isPinterestScriptAdded = false;
var pinterestClassNames = [".pinterest-pin", ".pinterest-board", ".pinterest-follow-button"].join(",");
exports.pinterestClassNames = pinterestClassNames;
var pinterestEmbedScript = "!function(a,b,c){var d,e,f;d=\"PIN_\"+~~((new Date).getTime()/864e5),a[d]?a[d]+=1:(a[d]=1,a.setTimeout(function(){e=b.getElementsByTagName(\"SCRIPT\")[0],f=b.createElement(\"SCRIPT\"),f.type=\"text/javascript\",f.async=!0,f.src=c.mainUrl+\"?\"+Math.random(),e.parentNode.insertBefore(f,e)},10))}(window,document,{mainUrl:\"//assets.pinterest.com/js/pinit_main.js\"});";

var pinterestBuild = function pinterestBuild() {
  if (typeof window.PinUtils !== "undefined" && window.PinUtils && typeof window.PinUtils.build === "function") {
    window.PinUtils.build();
  }
};

var handlePinterestBuild = function handlePinterestBuild() {
  if (document.querySelector(pinterestClassNames) !== null) {
    if (!isPinterestScriptAdded) {
      (0, _utils.createScriptTag)(null, pinterestEmbedScript);
      isPinterestScriptAdded = true;
      return {
        status: 'createScriptTag'
      };
    }
  }

  pinterestBuild();
  return {
    status: 'pinterestBuild'
  };
};

exports.handlePinterestBuild = handlePinterestBuild;

/***/ }),

/***/ 5742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "SimplecastEpisode", ({
  enumerable: true,
  get: function get() {
    return _simplecastEpisode.SimplecastEpisode;
  }
}));

var _simplecastEpisode = __webpack_require__(5110);

/***/ }),

/***/ 5110:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SimplecastEpisode = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SimplecastEpisode = function SimplecastEpisode(_ref) {
  var episodeId = _ref.episodeId,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? "light" : _ref$theme;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "simplecast-episode-mdx-embed",
    style: {
      position: 'relative',
      height: '200px',
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "simplecast-episode",
    title: "simplecast-".concat(episodeId),
    src: "https://player.simplecast.com/".concat(episodeId).concat(theme === "dark" ? "?dark=true" : ""),
    frameBorder: "no",
    scrolling: "no",
    seamless: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};

exports.SimplecastEpisode = SimplecastEpisode;

/***/ }),

/***/ 7594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Snack", ({
  enumerable: true,
  get: function get() {
    return _snack.Snack;
  }
}));

var _snack = __webpack_require__(5809);

/***/ }),

/***/ 5809:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Snack = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _utils = __webpack_require__(3781);

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scriptUrl = 'https://snack.expo.io/embed.js';

var Snack = function Snack(_ref) {
  var snackId = _ref.snackId,
      _ref$platform = _ref.platform,
      platform = _ref$platform === void 0 ? 'web' : _ref$platform,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'light' : _ref$theme;

  var handleScriptLoad = function handleScriptLoad() {
    (0, _utils.createScriptTag)(scriptUrl, null);
  };

  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: handleScriptLoad
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "snack-mdx-embed",
    "data-testid": "snack",
    "data-snack-id": snackId,
    "data-snack-platform": platform,
    "data-snack-preview": "true",
    "data-snack-theme": theme,
    style: {
      overflow: 'hidden',
      background: '#F9F9F9',
      border: '1px solid var(--color-border)',
      borderRadius: '4px',
      height: '505px',
      width: '100%'
    }
  }));
};

exports.Snack = Snack;

/***/ }),

/***/ 9136:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "SoundCloud", ({
  enumerable: true,
  get: function get() {
    return _soundcloud.SoundCloud;
  }
}));

var _soundcloud = __webpack_require__(7073);

/***/ }),

/***/ 7073:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SoundCloud = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SoundCloud = function SoundCloud(_ref) {
  var soundCloudLink = _ref.soundCloudLink,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'auto' : _ref$height,
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
      _ref$visual = _ref.visual,
      visual = _ref$visual === void 0 ? false : _ref$visual,
      color = _ref.color;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "soundcloud",
    title: "sound-cloud-".concat(soundCloudLink),
    className: "soundcloud-mdx-embed",
    width: width,
    height: height,
    scrolling: "no",
    frameBorder: "no",
    allow: "autoplay",
    src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/".concat(soundCloudLink, "&color=%23").concat(color, "&auto_play=").concat(autoPlay, "&visual=").concat(visual)
  }));
};

exports.SoundCloud = SoundCloud;

/***/ }),

/***/ 2674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Spotify", ({
  enumerable: true,
  get: function get() {
    return _spotify.Spotify;
  }
}));

var _spotify = __webpack_require__(2664);

/***/ }),

/***/ 2664:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Spotify = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Spotify = function Spotify(_ref) {
  var spotifyLink = _ref.spotifyLink,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 320 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 380 : _ref$height;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "spotify",
    title: "spotify-".concat(spotifyLink),
    className: "spotify-mdx-embed",
    src: "https://open.spotify.com/embed/".concat(spotifyLink),
    width: width,
    height: height,
    frameBorder: "0",
    allow: "encrypted-media"
  }));
};

exports.Spotify = Spotify;

/***/ }),

/***/ 89:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Strava", ({
  enumerable: true,
  get: function get() {
    return _strava.Strava;
  }
}));

var _strava = __webpack_require__(1084);

/***/ }),

/***/ 1084:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Strava = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Strava = function Strava(_ref) {
  var activityId = _ref.activityId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "strava",
    className: "strava-mdx-embed",
    style: {
      position: 'relative',
      height: '350px',
      maxWidth: '568px',
      width: '100%',
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    title: "strava-".concat(activityId),
    className: "strava-mdx-embed",
    height: "100%",
    width: "100%",
    style: {
      minWidth: '380px'
    },
    frameBorder: "0",
    scrolling: "no",
    src: "https://www.strava.com/activities/".concat(activityId)
  })));
};

exports.Strava = Strava;

/***/ }),

/***/ 7210:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "TikTok", ({
  enumerable: true,
  get: function get() {
    return _tiktok.TikTok;
  }
}));

var _tiktok = __webpack_require__(7593);

/***/ }),

/***/ 7593:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TikTok = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(5634);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TikTok = function TikTok(_ref) {
  var tikTokId = _ref.tikTokId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTikTokLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("blockquote", {
    "data-testid": "tiktok",
    className: "tiktok-embed",
    cite: "https://www.tiktok.com/".concat(tikTokId),
    "data-video-id": tikTokId.split('/').pop()
  }, /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://tiktok.com/".concat(tikTokId)
  }, typeof window !== 'undefined' && !window.tiktok ? 'Loading' : ''))));
};

exports.TikTok = TikTok;

/***/ }),

/***/ 5634:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleTikTokLoad = exports.tikTokClassNames = void 0;

var _utils = __webpack_require__(3781);

var isTikTokScriptAdded = false;
var tikTokClassNames = ".tiktok-embed";
exports.tikTokClassNames = tikTokClassNames;
var tikTokEmbedUrl = "https://www.tiktok.com/embed.js";

var handleTikTokLoad = function handleTikTokLoad() {
  if (document.querySelector(tikTokClassNames) !== null) {
    if (!isTikTokScriptAdded) {
      (0, _utils.createScriptTag)(tikTokEmbedUrl, null);
      isTikTokScriptAdded = true;
      return {
        status: 'createScriptTag'
      };
    }
  }

  return {
    status: 'null'
  };
};

exports.handleTikTokLoad = handleTikTokLoad;

/***/ }),

/***/ 6913:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Twitch", ({
  enumerable: true,
  get: function get() {
    return _twitch.Twitch;
  }
}));

var _twitch = __webpack_require__(422);

/***/ }),

/***/ 422:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Twitch = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _utils = __webpack_require__(3781);

var _generalObserver = __webpack_require__(7051);

var _utils2 = __webpack_require__(4602);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Twitch = function Twitch(_ref) {
  var parent = _ref.parent,
      twitchId = _ref.twitchId,
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
      _ref$skipTo = _ref.skipTo,
      skipTo = _ref$skipTo === void 0 ? {
    h: 0,
    m: 0,
    s: 0
  } : _ref$skipTo,
      _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? '' : _ref$channel,
      _ref$collection = _ref.collection,
      collection = _ref$collection === void 0 ? '' : _ref$collection;
  var h = skipTo.h,
      m = skipTo.m,
      s = skipTo.s;
  var title = twitchId ? "twitch-".concat(twitchId) : "twitch";
  var baseUrl = "https://player.twitch.tv/?autoplay=".concat(autoPlay, "&t=").concat(h, "h").concat(m, "m").concat(s, "s&parent=").concat( false ? 0 : parent);
  var constructedSrcURL = (0, _utils2.constructTwitchURL)(twitchId, channel, collection, baseUrl);
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "twitch",
    className: "twitch-mdx-embed",
    style: _objectSpread({
      position: 'relative',
      width: '100%'
    }, (0, _utils.getPadding)('16:9'))
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    title: title,
    src: constructedSrcURL // src={`https://clips.twitch.tv/embed?clip=AlertProductiveStingrayNononoCat&parent=${parent}`}
    ,
    frameBorder: "0",
    allow: "autoplay; fullscreen",
    allowFullScreen: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};

exports.Twitch = Twitch;

/***/ }),

/***/ 4602:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.constructTwitchURL = constructTwitchURL;

var _utils = __webpack_require__(3781);

function constructTwitchURL(twitchId, channel, collection, baseUrl) {
  var srcBlocks = [baseUrl];

  if (twitchId !== undefined) {
    srcBlocks.push("&video=v".concat(twitchId));
  } else if (!(0, _utils.isEmptyString)(channel)) {
    srcBlocks.push("&channel=".concat(channel));
  } else if (!(0, _utils.isEmptyString)(collection)) {
    srcBlocks.push("&collection=".concat(collection));
  }

  return srcBlocks.join('');
}

/***/ }),

/***/ 9597:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Tweet", ({
  enumerable: true,
  get: function get() {
    return _tweet.Tweet;
  }
}));
Object.defineProperty(exports, "TwitterFollowButton", ({
  enumerable: true,
  get: function get() {
    return _twitterFollowButton.TwitterFollowButton;
  }
}));
Object.defineProperty(exports, "TwitterHashtagButton", ({
  enumerable: true,
  get: function get() {
    return _twitterHashtagButton.TwitterHashtagButton;
  }
}));
Object.defineProperty(exports, "TwitterList", ({
  enumerable: true,
  get: function get() {
    return _twitterList.TwitterList;
  }
}));
Object.defineProperty(exports, "TwitterMentionButton", ({
  enumerable: true,
  get: function get() {
    return _twitterMentionButton.TwitterMentionButton;
  }
}));
Object.defineProperty(exports, "TwitterTimeline", ({
  enumerable: true,
  get: function get() {
    return _twitterTimeline.TwitterTimeline;
  }
}));

var _tweet = __webpack_require__(9228);

var _twitterFollowButton = __webpack_require__(3480);

var _twitterHashtagButton = __webpack_require__(1364);

var _twitterList = __webpack_require__(9564);

var _twitterMentionButton = __webpack_require__(2510);

var _twitterTimeline = __webpack_require__(9690);

/***/ }),

/***/ 9228:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Tweet = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(6791);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Tweet = function Tweet(_ref) {
  var tweetLink = _ref.tweetLink,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'light' : _ref$theme,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      _ref$hideConversation = _ref.hideConversation,
      hideConversation = _ref$hideConversation === void 0 ? false : _ref$hideConversation;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "twitter-tweet",
    className: "twitter-tweet-mdx-embed",
    style: {
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("blockquote", {
    className: "twitter-tweet",
    "data-theme": theme,
    "data-align": align,
    "data-conversation": hideConversation ? 'none' : ''
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://twitter.com/".concat(tweetLink, "?ref_src=twsrc%5Etfw")
  }, typeof window !== 'undefined' && !window.twttr ? 'Loading' : ''))));
};

exports.Tweet = Tweet;

/***/ }),

/***/ 3480:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TwitterFollowButton = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(6791);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TwitterFollowButton = function TwitterFollowButton(_ref) {
  var username = _ref.username,
      _ref$showFollowers = _ref.showFollowers,
      showFollowers = _ref$showFollowers === void 0 ? false : _ref$showFollowers,
      _ref$showUsername = _ref.showUsername,
      showUsername = _ref$showUsername === void 0 ? true : _ref$showUsername,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "twitter-follow-button",
    href: "https://twitter.com/".concat(username, "?ref_src=twsrc%5Etfw"),
    className: "twitter-follow-button twitter-follow-button-mdx-embed",
    "data-show-count": showFollowers,
    "data-show-screen-name": showUsername,
    "data-size": size
  }, "Follow @".concat(username)));
};

exports.TwitterFollowButton = TwitterFollowButton;

/***/ }),

/***/ 1364:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TwitterHashtagButton = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(6791);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TwitterHashtagButton = function TwitterHashtagButton(_ref) {
  var hashtag = _ref.hashtag,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "twitter-hashtag-button",
    href: "https://twitter.com/intent/tweet?button_hashtag=".concat(hashtag, "&ref_src=twsrc%5Etfw"),
    className: "twitter-hashtag-button twitter-hashtag-button-mdx-embed",
    "data-size": size
  }, "Tweet #".concat(hashtag)));
};

exports.TwitterHashtagButton = TwitterHashtagButton;

/***/ }),

/***/ 9564:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TwitterList = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(6791);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TwitterList = function TwitterList(_ref) {
  var username = _ref.username,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'light' : _ref$theme,
      listName = _ref.listName,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '498px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? null : _ref$height;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "twitter-list",
    className: "twitter-timeline twitter-timeline-mdx-embed",
    "data-theme": theme,
    "data-width": width,
    "data-height": height,
    href: "https://twitter.com/".concat(username, "/lists/").concat(listName, "?ref_src=twsrc%5Etfw")
  }, "A Twitter List by @".concat(username))));
};

exports.TwitterList = TwitterList;

/***/ }),

/***/ 2510:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TwitterMentionButton = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(6791);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TwitterMentionButton = function TwitterMentionButton(_ref) {
  var username = _ref.username,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "twitter-mention-button",
    href: "https://twitter.com/intent/tweet?screen_name=".concat(username, "&ref_src=twsrc%5Etfw"),
    className: "twitter-mention-button twitter-mention-button-mdx-embed",
    "data-size": size
  }, "Tweet to @".concat(username)));
};

exports.TwitterMentionButton = TwitterMentionButton;

/***/ }),

/***/ 9690:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TwitterTimeline = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

var _utils = __webpack_require__(6791);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TwitterTimeline = function TwitterTimeline(_ref) {
  var username = _ref.username,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'light' : _ref$theme,
      _ref$showLikes = _ref.showLikes,
      showLikes = _ref$showLikes === void 0 ? null : _ref$showLikes,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '498px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? null : _ref$height;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "twitter-timeline",
    className: "twitter-timeline twitter-timeline-mdx-embed",
    "data-theme": theme,
    "data-width": width,
    "data-height": height,
    href: "https://twitter.com/".concat(username).concat(showLikes ? "/likes" : '', "?ref_src=twsrc%5Etfw")
  }, "Tweets by @".concat(username))));
};

exports.TwitterTimeline = TwitterTimeline;

/***/ }),

/***/ 6791:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleTwttrLoad = exports.twttrClassNames = void 0;

var _utils = __webpack_require__(3781);

var isTwttrScriptAdded = false;
var twttrClassNames = [".twitter-tweet", ".twitter-timeline", ".twitter-follow-button", ".twitter-mention-button", ".twitter-hashtag-button"].join(",");
exports.twttrClassNames = twttrClassNames;
var twttrEmbedScript = "\n!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+\"://platform.twitter.com/widgets.js\";fjs.parentNode.insertBefore(js,fjs);}}(document,\"script\",\"twitter-wjs\")\n";

var twttrLoad = function twttrLoad() {
  if (typeof window.twttr !== "undefined" && window.twttr.widgets && typeof window.twttr.widgets.load === "function") {
    window.twttr.widgets.load(document.getElementsByClassName("mdx-embed"));
  }
};

var handleTwttrLoad = function handleTwttrLoad() {
  if (document.querySelector(twttrClassNames) !== null) {
    if (!isTwttrScriptAdded) {
      (0, _utils.createScriptTag)(null, twttrEmbedScript);
      isTwttrScriptAdded = true;
      return {
        status: 'createScriptTag'
      };
    }
  }

  twttrLoad();
  return {
    status: 'twttrLoad'
  };
};

exports.handleTwttrLoad = handleTwttrLoad;

/***/ }),

/***/ 9710:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Vimeo", ({
  enumerable: true,
  get: function get() {
    return _vimeo.Vimeo;
  }
}));

var _vimeo = __webpack_require__(9423);

/***/ }),

/***/ 9423:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Vimeo = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _utils = __webpack_require__(3781);

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Vimeo = function Vimeo(_ref) {
  var vimeoId = _ref.vimeoId,
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
      _ref$skipTo = _ref.skipTo,
      skipTo = _ref$skipTo === void 0 ? {
    h: 0,
    m: 0,
    s: 0
  } : _ref$skipTo;
  var h = skipTo.h,
      m = skipTo.m,
      s = skipTo.s;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "vimeo",
    className: "vimeo-mdx-embed",
    style: _objectSpread({
      position: 'relative',
      width: '100%'
    }, (0, _utils.getPadding)('16:9'))
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    title: "vimeo-".concat(vimeoId),
    src: "https://player.vimeo.com/video/".concat(vimeoId, "?autoplay=").concat(autoPlay, "#t=").concat(h, "h").concat(m, "m").concat(s, "s"),
    frameBorder: "0",
    allow: "autoplay; fullscreen",
    allowFullScreen: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};

exports.Vimeo = Vimeo;

/***/ }),

/***/ 5033:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Whimsical", ({
  enumerable: true,
  get: function get() {
    return _whimsical.Whimsical;
  }
}));

var _whimsical = __webpack_require__(2267);

/***/ }),

/***/ 2267:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Whimsical = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getPadding(aspectRatio) {
  var regExp = /^([1-9]\d*):([1-9]\d*)$/;

  var _ref = regExp.exec(aspectRatio) || ['', '1', '1'],
      _ref2 = _slicedToArray(_ref, 3),
      width = _ref2[1],
      height = _ref2[2];

  return {
    paddingTop: "".concat(100 * parseInt(height, 10) / parseInt(width, 10), "%")
  };
}

var Whimsical = function Whimsical(_ref3) {
  var diagramId = _ref3.diagramId,
      _ref3$aspectRatio = _ref3.aspectRatio,
      aspectRatio = _ref3$aspectRatio === void 0 ? '1:1' : _ref3$aspectRatio;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "whimsical",
    className: "whimsical-mdx-embed",
    style: _objectSpread({
      position: 'relative',
      width: '100%'
    }, getPadding(aspectRatio))
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    title: "whimsical-".concat(diagramId),
    src: "https://whimsical.com/embed/".concat(diagramId),
    frameBorder: "0",
    allowFullScreen: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};

exports.Whimsical = Whimsical;

/***/ }),

/***/ 3055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Wikipedia", ({
  enumerable: true,
  get: function get() {
    return _wikipedia.Wikipedia;
  }
}));

var _wikipedia = __webpack_require__(4254);

/***/ }),

/***/ 4254:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Wikipedia = void 0;

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _generalObserver = __webpack_require__(7051);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Wikipedia = function Wikipedia(_ref) {
  var wikipediaLink = _ref.wikipediaLink,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 600 : _ref$height;

  var _useState = (0, _react.useState)({
    isLoading: true,
    hasError: false,
    body: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      wikiResponse = _useState2[0],
      setWikiResponse = _useState2[1];

  var wikipediaEmbedUrl = "https://en.wikipedia.org/api/rest_v1/page/html/".concat(wikipediaLink);
  (0, _react.useEffect)(function () {
    fetch(wikipediaEmbedUrl).then(function (response) {
      return response.text();
    }).then(function (response) {
      if (response) {
        setWikiResponse({
          isLoading: false,
          hasError: false,
          body: response.replace(/<a rel="mw:WikiLink"/g, '<a target="_blank" rel="mw:WikiLink"')
        });
      }

      if (!response) {
        setWikiResponse({
          isLoading: false,
          hasError: true
        });
      }
    });
  }, [wikipediaEmbedUrl]);
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, !wikiResponse.isLoading && /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "wikipedia",
    className: "wikipedia-mdx-embed",
    title: wikipediaLink,
    frameBorder: "0",
    style: {
      width: '100%',
      minHeight: height
    },
    srcDoc: wikiResponse.body
  }));
};

exports.Wikipedia = Wikipedia;

/***/ }),

/***/ 3850:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Wistia", ({
  enumerable: true,
  get: function get() {
    return _wistia.Wistia;
  }
}));

var _wistia = __webpack_require__(7387);

/***/ }),

/***/ 4798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleWistiaLoad = void 0;

var _utils = __webpack_require__(3781);

var isWistiaAdded = false;
var embedUrl = "https://fast.wistia.net/assets/external/E-v1.js";

var handleWistiaLoad = function handleWistiaLoad() {
  if (isWistiaAdded) {
    return;
  }

  (0, _utils.createScriptTag)(embedUrl, null);
  isWistiaAdded = true;
};

exports.handleWistiaLoad = handleWistiaLoad;

/***/ }),

/***/ 7387:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Wistia = void 0;

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _utils = __webpack_require__(3781);

var _generalObserver = __webpack_require__(7051);

var _utils2 = __webpack_require__(4798);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Wistia = function Wistia(_ref) {
  var videoId = _ref.videoId,
      _ref$allowFullScreen = _ref.allowFullScreen,
      allowFullScreen = _ref$allowFullScreen === void 0 ? true : _ref$allowFullScreen,
      _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? '16:9' : _ref$aspectRatio,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay;
  // Implemented as config array to support further extension
  var config = [];
  if (autoPlay) config.push('autoPlay=true');
  (0, _react.useEffect)(function () {
    (0, _utils2.handleWistiaLoad)();
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wistia-mdx-embed",
    style: _objectSpread({
      position: 'relative',
      width: '100%'
    }, (0, _utils.getPadding)(aspectRatio))
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    src: "https://fast.wistia.net/embed/iframe/".concat(videoId).concat(config.length > 0 ? '?' + config.join('&') : ''),
    "data-testid": "wistia",
    allow: "autoplay; ".concat(allowFullScreen ? 'fullscreen' : ''),
    frameBorder: "0",
    scrolling: "no",
    className: "wistia-mdx-embed-iframe",
    allowFullScreen: allowFullScreen,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: width,
      height: height
    }
  })));
};

exports.Wistia = Wistia;

/***/ }),

/***/ 837:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "YouTube", ({
  enumerable: true,
  get: function get() {
    return _youtube.YouTube;
  }
}));

var _youtube = __webpack_require__(8449);

/***/ }),

/***/ 8449:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.YouTube = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _utils = __webpack_require__(3781);

var _generalObserver = __webpack_require__(7051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var YouTube = function YouTube(_ref) {
  var youTubeId = _ref.youTubeId,
      _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? '16:9' : _ref$aspectRatio,
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
      _ref$skipTo = _ref.skipTo,
      skipTo = _ref$skipTo === void 0 ? {
    h: 0,
    m: 0,
    s: 0
  } : _ref$skipTo,
      _ref$noCookie = _ref.noCookie,
      noCookie = _ref$noCookie === void 0 ? false : _ref$noCookie;
  var h = skipTo.h,
      m = skipTo.m,
      s = skipTo.s;
  var tH = h * 60;
  var tM = m * 60;
  var startTime = tH + tM + s;
  var provider = noCookie ? "www.youtube-nocookie.com" : "www.youtube.com";
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "youtube-mdx-embed",
    style: _objectSpread({
      position: 'relative',
      width: '100%'
    }, (0, _utils.getPadding)(aspectRatio))
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "youtube",
    title: "youTube-".concat(youTubeId),
    src: "https://".concat(provider, "/embed/").concat(youTubeId, "?&autoplay=").concat(autoPlay, "&start=").concat(startTime),
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};

exports.YouTube = YouTube;

/***/ }),

/***/ 6222:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _airtable.AirtableBase;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _airtable.AirtableForm;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _buzzsprout.Buzzsprout;
  }
});
Object.defineProperty(exports, "sp", ({
  enumerable: true,
  get: function get() {
    return _codepen.CodePen;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _codesandbox.CodeSandbox;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _egghead.EggheadLesson;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _flickr.Flickr;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _figma.Figma;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _gist.Gist;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _instagram.Instagram;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _lbry.Lbry;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _linkedin.LinkedInBadge;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _pinterest.Pin;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _pinterest.PinterestBoard;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _pinterest.PinterestFollowButton;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _simplecast.SimplecastEpisode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _soundcloud.SoundCloud;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _spotify.Spotify;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _strava.Strava;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _snack.Snack;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _tiktok.TikTok;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _twitch.Twitch;
  }
});
Object.defineProperty(exports, "tP", ({
  enumerable: true,
  get: function get() {
    return _twitter.Tweet;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _twitter.TwitterFollowButton;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _twitter.TwitterHashtagButton;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _twitter.TwitterList;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _twitter.TwitterMentionButton;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _twitter.TwitterTimeline;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _vimeo.Vimeo;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _whimsical.Whimsical;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _wikipedia.Wikipedia;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _wistia.Wistia;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _youtube.YouTube;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _mdxEmbedProvider.MDXEmbedProvider;
  }
});

var _airtable = __webpack_require__(1177);

var _buzzsprout = __webpack_require__(5738);

var _codepen = __webpack_require__(9131);

var _codesandbox = __webpack_require__(9186);

var _egghead = __webpack_require__(2269);

var _flickr = __webpack_require__(3926);

var _figma = __webpack_require__(941);

var _gist = __webpack_require__(332);

var _instagram = __webpack_require__(376);

var _lbry = __webpack_require__(3501);

var _linkedin = __webpack_require__(9744);

var _pinterest = __webpack_require__(2035);

var _simplecast = __webpack_require__(5742);

var _soundcloud = __webpack_require__(9136);

var _spotify = __webpack_require__(2674);

var _strava = __webpack_require__(89);

var _snack = __webpack_require__(7594);

var _tiktok = __webpack_require__(7210);

var _twitch = __webpack_require__(6913);

var _twitter = __webpack_require__(9597);

var _vimeo = __webpack_require__(9710);

var _whimsical = __webpack_require__(5033);

var _wikipedia = __webpack_require__(3055);

var _wistia = __webpack_require__(3850);

var _youtube = __webpack_require__(837);

var _mdxEmbedProvider = __webpack_require__(1071);

/***/ }),

/***/ 3781:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isEmptyString = exports.createStyleSheet = exports.createScriptTag = exports.getPadding = void 0;

var getPadding = function getPadding(aspectRatio) {
  var config = {
    '1:1': {
      paddingTop: '100%'
    },
    '16:9': {
      paddingTop: '56.25%'
    },
    '4:3': {
      paddingTop: '75%'
    },
    '3:2': {
      paddingTop: '66.66%'
    },
    '8.5': {
      paddingTop: '62.5%'
    }
  }; // @ts-ignore

  return config[aspectRatio];
};

exports.getPadding = getPadding;

var createScriptTag = function createScriptTag(providerEmbedUrl, providerEmbedScript) {
  var script = document.createElement("script");
  script.type = "text/javascript";

  if (providerEmbedUrl) {
    script.src = providerEmbedUrl;
  }

  if (providerEmbedScript) {
    script.innerText = providerEmbedScript;
  }

  script.onerror = function (error) {
    console.error("MDXEmbedProvider ".concat(error.type), error);
  };

  document.getElementsByTagName("head")[0].appendChild(script);
};

exports.createScriptTag = createScriptTag;

var createStyleSheet = function createStyleSheet(href) {
  var link = document.createElement("link");
  link.type = "text/css";
  link.rel = "stylesheet";
  link.href = href;
  document.getElementsByTagName("head")[0].appendChild(link);
};

exports.createStyleSheet = createStyleSheet;

var isEmptyString = function isEmptyString(value) {
  return value === null || value === undefined || value.length === 0;
};

exports.isEmptyString = isEmptyString;

/***/ }),

/***/ 3194:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8773)


/***/ }),

/***/ 8773:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.getMDXComponent = getMDXComponent;
__webpack_unused_export__ = getMDXExport;

var React = _interopRequireWildcard(__webpack_require__(7294));

var _jsx_runtime = _interopRequireWildcard(__webpack_require__(5893));

var ReactDOM = _interopRequireWildcard(__webpack_require__(3935));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * @typedef {import('mdx/types').MDXComponents} ComponentMap
 */

/**
 * @typedef {{[props: string]: unknown, components?: ComponentMap}} MDXContentProps
 */

/**
 *
 * @param {string} code - The string of code you got from bundleMDX
 * @param {Record<string, unknown>} [globals] - Any variables your MDX needs to have accessible when it runs
 * @return {React.FunctionComponent<MDXContentProps>}
 */
function getMDXComponent(code, globals) {
  const mdxExport = getMDXExport(code, globals);
  return mdxExport.default;
}
/**
 * @template ExportedObject
 * @template Frontmatter
 * @type {import('./types').MDXExportFunction<ExportedObject, Frontmatter>}
 * @param {string} code - The string of code you got from bundleMDX
 * @param {Record<string, unknown>} [globals] - Any variables your MDX needs to have accessible when it runs
 *
 */


function getMDXExport(code, globals) {
  const scope = {
    React,
    ReactDOM,
    _jsx_runtime,
    ...globals
  }; // eslint-disable-next-line

  const fn = new Function(...Object.keys(scope), code);
  return fn(...Object.values(scope));
}

/***/ })

}]);